import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaInstagram, FaYoutube, FaEnvelope, FaArrowUp } from 'react-icons/fa';
import '../styles/Footer.css';

const SECTIONS = [
  { name: 'حملي', val: 'pregnancy' },
  { name: 'طفلي', val: 'childcare' },
  { name: 'بيتي', val: 'home' },
  { name: 'كوزينتي', val: 'recipes' },
  { name: 'مدرستي', val: 'education' },
  { name: 'صحتي', val: 'health' }
];

const Footer = () => {
  const toTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <footer className="footer scallop-top">
      <div className="footer-container">
        <div className="footer-section footer-about">
          <div className="footer-logo">
            <span className="footer-mark" aria-hidden="true" />
            <h3>Maman Algérienne</h3>
          </div>
          <p className="footer-note">
            مجتمعكن الآمن للنصائح والمنتجات المناسبة لكن ولعائلتكن.
            نكتب هنا بحب، خطوة بخطوة، مع كل أم.
          </p>
          <div className="social-icons">
            <a href="https://www.facebook.com/MamanAlgerienne/" target="_blank" rel="noopener noreferrer" aria-label="فيسبوك"><FaFacebookF aria-hidden="true" /></a>
            <a href="https://www.instagram.com/mamanalgerienne/" target="_blank" rel="noopener noreferrer" aria-label="إنستغرام"><FaInstagram aria-hidden="true" /></a>
            <a href="https://www.youtube.com/c/mamanalgerienne" target="_blank" rel="noopener noreferrer" aria-label="يوتيوب"><FaYoutube aria-hidden="true" /></a>
          </div>
        </div>

        <nav className="footer-section" aria-label="روابط سريعة">
          <h3>روابط سريعة</h3>
          <ul>
            <li><Link to="/">الرئيسية</Link></li>
            <li><Link to="/articles">المقالات</Link></li>
            <li><Link to="/products">المنتجات</Link></li>
            <li><Link to="/links">التحميلات</Link></li>
            <li><Link to="/cart">سلة التسوق</Link></li>
          </ul>
        </nav>

        <nav className="footer-section" aria-label="الأقسام">
          <h3>الأقسام</h3>
          <ul>
            {SECTIONS.map((c) => (
              <li key={c.val}><Link to={'/articles?category=' + c.val}>{c.name}</Link></li>
            ))}
          </ul>
        </nav>

        <div className="footer-section">
          <h3>تواصلي معنا</h3>
          <ul className="contact-info">
            <li>
              <FaEnvelope aria-hidden="true" />
              <a href="mailto:mamanalgeriennepartenariat@gmail.com">mamanalgeriennepartenariat@gmail.com</a>
            </li>
          </ul>
          <p className="footer-hand">نسعد برسائلكن دائماً</p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Maman Algérienne — صُنع بحب في الجزائر</p>
        <button type="button" className="to-top" onClick={toTop}>
          <FaArrowUp aria-hidden="true" /> العودة للأعلى
        </button>
      </div>
    </footer>
  );
};

export default Footer;
